import url from '../../../utils/url.js'
const DEFAULT_TAB = 'tab1'

export default {
  data () {
    return {
      tabView: DEFAULT_TAB
    }
  },
  created () {
    if (this.$route.query.tabView) {
      this.setTabViewFromRoute()
    }
  },
  watch: {
    '$route': function () {
      this.setTabViewFromRoute()
    },
    'tabView': function () {
      let route = url.getRoute(this.$route)
      route.query.tabView = this.tabView
      this.$router.replace(route)
    }
  },
  methods: {
    setTabViewFromRoute () {
      this.tabView = this.$route.query.tabView || DEFAULT_TAB
    },
    activeClass (tab) {
      if (tab === this.tabView) {
        return 'active'
      }
      return ''
    }
  }
}
